module.exports = __webpack_public_path__ + "img/Woman_Analyzing_Data_Scorecard_Row.cbed799f.jpg";